<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('commonTcpaEconsentDisclosureTitle')"
    [size]="'large'"
    [isLoading]="isLoading()"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <div id="paperless-disclosure-content" class="max-h-[25vh] overflow-y-auto p-6">
        <div class="font-dm text-sm text-ld-neutral leading-relaxed space-y-3">
          <p id="paperless-disclosure-intro">
            {{ t('modalsPaperlessDisclosureIntro') }}
          </p>

          <p id="paperless-disclosure-paper-right">
            {{ t('modalsPaperlessDisclosurePaperRight') }}
          </p>

          <p id="paperless-disclosure-withdraw">
            {{ t('modalsPaperlessDisclosureWithdraw') }}
          </p>

          <p id="paperless-disclosure-scope">
            {{ t('modalsPaperlessDisclosureScope') }}
          </p>

          <p id="paperless-disclosure-confirm-access">
            {{ t('modalsPaperlessDisclosureConfirmAccess') }}
          </p>

          <p id="paperless-disclosure-requirements-intro">
            {{ t('modalsPaperlessDisclosureRequirementsIntro') }}
          </p>

          <ul id="paperless-disclosure-requirements-list" class="list-disc pl-6 space-y-1">
            <li>{{ t('modalsPaperlessDisclosureRequirementsDevice') }}</li>
            <li>{{ t('modalsPaperlessDisclosureRequirementsBrowser') }}</li>
            <li>{{ t('modalsPaperlessDisclosureRequirementsInternet') }}</li>
            <li>{{ t('modalsPaperlessDisclosureRequirementsStorage') }}</li>
            <li>{{ t('modalsPaperlessDisclosureRequirementsEmail') }}</li>
            <li>{{ t('modalsPaperlessDisclosureRequirementsSoftware') }}</li>
          </ul>

          <p id="paperless-disclosure-acceptance">
            {{ t('modalsPaperlessDisclosureAcceptance') }}
          </p>
        </div>
      </div>
    </div>
    <div modal-footer class="flex-col! items-stretch! gap-4!">
      <div id="paperless-disclosure-agree-section" class="flex items-center gap-2">
        <mat-checkbox
          id="paperless-disclosure-agree-checkbox"
          [checked]="isChecked()"
          [disabled]="isLoading()"
          (change)="onCheckboxChange()"
        />
        <label
          id="paperless-disclosure-agree-label"
          for="paperless-disclosure-agree-checkbox"
          class="font-dm text-sm text-ld-neutral leading-5 cursor-pointer"
          tabindex="0"
          (click)="onCheckboxChange()"
          (keydown.enter)="onCheckboxChange()"
        >
          {{ t('modalsPaperlessDisclosureAgreeLabel') }}
        </label>
      </div>

      <div id="paperless-disclosure-actions" class="flex items-center justify-end gap-3">
        <button
          id="paperless-disclosure-cancel-btn"
          type="button"
          class="btn-outline-ld-purple"
          [disabled]="isLoading()"
          (click)="onCancel()"
        >
          {{ t('commonButtonsCancel') }}
        </button>
        <button
          id="paperless-disclosure-submit-btn"
          type="button"
          class="btn-primary-ld-purple"
          [disabled]="!isChecked() || isLoading()"
          (click)="onSubmit()"
        >
          @if (isLoading()) {
            <span class="flex items-center gap-2">
              <span
                class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
              ></span>
              {{ t('paperlessSettingsButtonsSaving') }}
            </span>
          } @else {
            {{ t('commonSubmit') }}
          }
        </button>
      </div>
    </div>
  </ld-base-modal>
</ng-container>
